import { helper } from '@ember/component/helper';

import { or } from 'rise-ui/utils/choice.js';

export default helper(function orHelper(values) {
  return or(...values);
});
